/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Driverremittance_Status_Pending1Inputs */

const vi_driverremittance_status_pending1 = /** @type {(inputs: Driverremittance_Status_Pending1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chờ xác nhận`)
};

/**

* @param {Driverremittance_Status_Pending1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const driverremittance_status_pending1 = /** @type {((inputs?: Driverremittance_Status_Pending1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Driverremittance_Status_Pending1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_driverremittance_status_pending1(inputs)
});
export { driverremittance_status_pending1 as "driverRemittance_status_pending" }